module.exports = __webpack_public_path__ + "media/images/Groupe 180-f502f0e0eb15fc8bf813ca826904ea5c.svg";